import React from 'react';
import { Slider as AntSlider } from 'antd';

/**
 * Wrapper component for Ant Design Slider
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Slider functionality including range, marks, step, and tooltip options.
 * 
 * @component
 * @example
 * import { Slider } from '../GeneralComponents/ui';
 * 
 * <Slider defaultValue={30} />
 * <Slider range defaultValue={[20, 50]} />
 * <Slider
 *   marks={{
 *     0: '0°C',
 *     26: '26°C',
 *     37: '37°C',
 *     100: '100°C',
 *   }}
 * />
 * 
 * @see https://ant.design/components/slider/ - Ant Design Slider documentation
 */
const Slider = (props) => {
  return <AntSlider {...props} />;
};

export default Slider;

